import { AuthContextProps } from 'Auth/shared/models/Context'
import React from 'react'

export const AuthContext = React.createContext<AuthContextProps | undefined>(
  undefined
)
